import JWT from 'jsonwebtoken'
import { API_HOST } from '../env'

const getUserSession = async () => {
  try {
    const session = await fetch(`${API_HOST}/session`, { credentials: 'include' })
      .then(resp => resp.json())

    if (session.token) {
      const decodedToken = JWT.decode(session.token)
      const userSession = {
        firstName: decodedToken.given_name,
        lastName: decodedToken.family_name,
        email: decodedToken.email,
      }

      if (decodedToken.iss.match(/onelogin/)) {
        userSession.role = 'COACH'
      }

      if (decodedToken.iss.match(/cognito-idp/)) {
        userSession.role = 'CONSUMER'
      }

      return userSession
    }
    return null
  } catch {
    return null
  }
}

const login = async (username, password) => {
  return await fetch(`${API_HOST}/consumer/v1/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ username, password }),
  }).then(async resp => {
    const data = await resp.json()
    return {
      isSuccess: resp.ok,
      error: data.error,
    }
  })
}

const forgotPassword = async (username) => {
  return await fetch(`${API_HOST}/consumer/v1/forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username }),
  }).then(async resp => {
    const { message } = await resp.json()
    return {
      success: resp.ok,
      message,
    }
  })
}

const confirmForgotPassword = async (username, password, confirmationCode) => {
  return await fetch(`${API_HOST}/consumer/v1/confirm-forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, password, confirmationCode }),
  }).then(async resp => {
    const { message } = await resp.json()
    return {
      success: resp.ok,
      message,
    }
  })
}

export { getUserSession, login, forgotPassword, confirmForgotPassword }
